import { useEffect, useRef, useState } from 'react';
import { SliderInput, SliderWrap } from 'components/Slider/styles';
import {ShadingSliderWrap } from './style';

const getSliderlinearGrad = (val: number, active:boolean) => `linear-gradient(to right, ${active? 'var(--secondary)': 'var(--sliderFillColor)'} 0%, ${active? 'var(--secondary)': 'var(--sliderFillColor)'} ${val}%, var(--sliderTrackColor) ${val}%, var(--sliderTrackColor) 100%)`;
export default function ShadingSlider(props: { 
	shading: number, 
	onChange?: (value: string) => void , 
	active: boolean,
	disabled?: boolean
}) {
	const sliderRef = useRef<HTMLInputElement | null>(null);
	const [shadingVal, setShadingVal]= useState<number>(props.shading);

	useEffect(() => {
		setShadingVal(props.shading);
	}, [props.shading]);

	return (
		<SliderWrap className='shading-wrap'>
			<ShadingSliderWrap className="shading-label">
				<label>Shading:</label>
				<span className="shading-percentage">{Math.round(shadingVal * 100) / 100}</span>
			</ShadingSliderWrap>
			<SliderInput
				type='range'
				className='facet-slider-range'
				min={0}
				max={70}
				defaultValue={props.shading}
				value={shadingVal}
				step={1}
				ref={sliderRef}
				disabled={props.disabled}
				style={{background: getSliderlinearGrad((shadingVal / 70) * 100, props.active)}}
				onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
					const value = Math.ceil(+e.target.value);
					e.target.value = value.toString();
					setShadingVal(value);
					props.onChange?.(e.target.value);
				}}
			/>
		</SliderWrap>
	);
}
